import React from "react"

import "./Description.scss"

const Description = (props) => {
  return (
    <div className="description-section">
      <div className="description-section__text" dangerouslySetInnerHTML={{ __html: props.acf.description }} />
    </div>
  )
}

export default Description
